import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { TagTheme, ToggleSwitchStatus } from '@fcom/ui-components';

@Component({
  selector: 'fin-seat-bundle-toggle',
  templateUrl: './seat-bundle-toggle.component.html',
  styleUrls: ['./seat-bundle-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeatBundleToggleComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TagTheme = TagTheme;
  readonly ToggleSwitchStatus = ToggleSwitchStatus;

  @Input({ required: true }) discountPercentage: string;
  @Input({ required: true }) active: boolean;
  @Output() bundleToggled: EventEmitter<boolean> = new EventEmitter();

  emitToggle(toggled: boolean): void {
    this.bundleToggled.emit(toggled);
  }
}
